import React, { useEffect, useState } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useSelector, useDispatch } from 'react-redux'
import { setCurrProjectId } from "../../reducers/ParamSlice"
import {test } from "../../reducers/ThemeSlice"
import { GET_PROJECT_RESET } from "../../constants/projectsConstants"
// MUI (Material UI) components
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Button,
  Typography,
  useTheme,
  alpha,
  Link,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,

} from "@mui/material";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import {
  getProjectsList,
  getProject,
  renameProject,
  deleteProject,
} from "../../actions/projectsActions"

import {

  EditRounded,
  DeleteOutlineRounded,

  ClearRounded,
  SaveRounded,
} from "@mui/icons-material";

function useDialogState(initial = false) {
  const [open, setOpen] = useState(initial);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  return { open, onOpen, onClose };
}


export default function SortableProjectCard({ project, activeId }) {
  const dispatch = useDispatch()
  const dlg = useDialogState();
  const [form, setForm] = useState({ title: project.title });

  const navigate = useNavigate();
  const theme = useTheme();
  const { id } = project;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 50 : undefined,
  };

  const isActive = activeId === id;

  function startNew() {
    setForm({ title: project.title });
    dlg.onOpen();
  }
  function startEdit(title) {
    setForm({ title: title });
    dlg.onOpen();
  }

  function submit() {
    dispatch(renameProject(project.id, form))
    dlg.onClose();
  }
  useEffect(() => {
    dispatch({ type: GET_PROJECT_RESET })
    dispatch(setCurrProjectId(0))
  }, [])
  // setTimeout(() => {
  //   // @ts-ignore for quick debug in browser
  //   console.log('param slice right now:', store.getState().param);
  // }, 0);

  return (
    <>
      <Card ref={setNodeRef} sx={{
        ...style,
        borderRadius: 3,
        border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
        boxShadow: isDragging ? 6 : 1,
        outline: isActive ? `2px solid ${theme.palette.primary.main}` : "none",
        backdropFilter: "blur(8px)",

      }}
      >

        <CardActionArea disableRipple

        >
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              {/* Drag handle */}
              <Button
                component="span"
                size="small"
                aria-label="Drag project"
                {...attributes}
                {...listeners}
                sx={{
                  minWidth: 0,
                  p: 1,
                  color: "text.secondary",
                  cursor: "grab",
                  '&:active': { cursor: "grabbing" },
                }}
              >
                <DragIndicatorRoundedIcon /> 
              </Button>


              <Box sx={{ flex: 1 }}>
                <Link
                  component={RouterLink}
                  to="/project"
                  onClick={() => {
                    dispatch(getProject(project.id));
                    console.log(project.id);
                    dispatch(setCurrProjectId(project.id));
                  }}
                >
                  <Typography variant="h6" component="h3" gutterBottom>
                    {project.title}
                  </Typography>
                </Link>
                <Typography variant="body2" color="text.secondary">
                  {project.description}
                </Typography>

                <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                  {project.tags?.map((t) => (
                    <Chip key={t} label={`#${t}`} size="small" variant="outlined" />
                  ))}
                </Stack>
              </Box>
              <Stack direction="row" spacing={0.5}>

                <Tooltip title="Edit">
                  <IconButton size="small"
                    component="span"
                    onClick={() => {
                      startEdit(form.title)
                    }
                    }
                  >
                    <EditRounded fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton size="small"
                    component="span"
                    onClick={() => dispatch(deleteProject(project.id))}
                  >
                    <DeleteOutlineRounded fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>

          </CardContent>
        </CardActionArea>

      </Card>
      <Dialog open={dlg.open} onClose={dlg.onClose} fullWidth maxWidth="sm">
        <DialogTitle>{"Rename Project"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Title" value={form.title} onChange={(e) => setForm({ title: e.target.value })} autoFocus />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button startIcon={<ClearRounded />} onClick={dlg.onClose}>Cancel</Button>
          <Button startIcon={<SaveRounded />} variant="contained" onClick={submit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
